import { PAGE_LINKS } from '@/router/pageConst'
import { userService, useUserInfo } from '@/services/userService'
import { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './HomePageMobile.module.less'
import cls from 'classnames'
import { commonUtils } from '@/helpers/commonUtils'
import AIcon from '@/components/A/AIcon/AIcon'
import MiddleText from '@/components/MiddleText/MiddleText'
import CookieAcceptNotification from '@/components/CookieAcceptNotification/CookieAcceptNotification'
import { observer } from 'mobx-react'
import { corpService } from '@/services/corpService'
import { INTERNAL_HOST } from '@/commonConst'
import AigcPromoEntry from '../AigcPromoEntry/AigcPromoEntry'
import { useTypedLocalStorage } from '@/helpers/commonHooks/useTypedLocalStorage'
import AigcPromotionDrawer from '../AigcPromotionDrawer/AigcPromotionDrawer'

const StartBtn = observer(() => {
  const { t } = useTranslation()
  const [hover, setHover] = useState(false)
  const navigate = useNavigate()
  return (
    <button
      data-testid='home-start-btn'
      className={cls(styles.startBtn, { [styles.hover]: hover })}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => {
        if (userService.userInfo) {
          navigate(PAGE_LINKS.contact)
        } else {
          navigate(PAGE_LINKS.login)
        }
      }}
    >
      <span>{t('landing.startBtn')}</span>
      {hover ? (
        <img src={commonUtils.getImagePath('homePage/right-arrow-icon-white.png')} alt='' />
      ) : (
        <img src={commonUtils.getImagePath('homePage/right-arrow-icon-black.png')} alt='' />
      )}
    </button>
  )
})

const FreeTrialBtn = observer(() => {
  const { t } = useTranslation()
  const [hover, setHover] = useState(false)
  const navigate = useNavigate()
  return (
    <button
      data-testid='home-free-trial-btn'
      className={cls(styles.startBtn, { [styles.hover]: hover })}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => {
        navigate(PAGE_LINKS.freeTrial)
      }}
    >
      <span>{t('modals.freeTrialModal.title')}</span>
      {hover ? (
        <img src={commonUtils.getImagePath('homePage/right-arrow-icon-white.png')} alt='' />
      ) : (
        <img src={commonUtils.getImagePath('homePage/right-arrow-icon-black.png')} alt='' />
      )}
    </button>
  )
})

const ContactUsBtn = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <button className={cls(styles.contactUsBtn)} data-testid='home-contact-us-btn' onClick={() => {
      navigate(PAGE_LINKS.contact)
    }}>
      <MiddleText text={t('pageHeader.contactUs')} />
      <AIcon className={styles.icon} type='icon-line-global_arrow1' />
    </button>
  )
})

function HomePageMobile() {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const browserType = commonUtils.getMobileBrowserType()
  const platformType = commonUtils.getMobilePlatformType()
  const userInfo = useUserInfo()
  const [hasUserInfo, setHasUserInfo] = useState<boolean>(false)
  const [showAigcEntry, setShowAigcEntry] = useState(false)
  const [showAigcPromotionDrawer, setShowAigcPromotionDrawer] = useState(false)
  const [showCookieDrawer, setShowCookieDrawer] = useState(false)
  const [, setIsFrom] = useTypedLocalStorage('is_from', { defaultValue: '' })

  useEffect(() => {
    const one: boolean = Boolean(userInfo)
    const two: boolean = !userInfo?.isExpert
    const hasUserInfo = one && two
    setHasUserInfo(hasUserInfo)
    if (hasUserInfo) {
      corpService.refreshFreeTrialStatus()
    }
  }, [userInfo])

  const openAigcPromotionDrawer = () => {
    setShowAigcEntry(false)
    setShowCookieDrawer(false)
    setShowAigcPromotionDrawer(true)
  }

  const closeAigcPromotionDrawer = () => {
    setShowAigcPromotionDrawer(false)
    setShowCookieDrawer(true)
    if (userInfo === null) {
      setShowAigcEntry(true)
    }
  }

  const handleAigcRegister = () => {
    setIsFrom('aigc')
    setShowAigcPromotionDrawer(false)
    navigate(PAGE_LINKS.login, { state: { mode: 'sign' } })
  }

  useEffect(() => {
    if (userInfo === undefined) {
      return
    }
    setShowAigcEntry(userInfo === null)
    setShowCookieDrawer(true)
  }, [userInfo])



  return (
    <>
      <div className={styles.mobileHomePage} data-testid='home-page'>
        <div className={styles.bannerBox}>
          <img className={styles.bannerBg} src={commonUtils.getImagePath('homePageMobile/banner-bg.png')} alt="" />
          <div className={cls(styles.bannerContent, styles[i18n.language])}>
            <div className={styles.titleBox}>
              <img
                className={cls(styles.aiLine, styles[i18n.language])}
                src={commonUtils.getImagePath('homePage/ai-line.png')}
                alt=''
              />
              <span className={cls(styles.highlight, styles.text, styles[i18n.language])}>
                {t('landing.banner.text1')}
              </span>
            </div>
            <div className={cls(styles.titleBox, styles.second)}>
              <span className={cls(styles.text, styles[i18n.language])}>
                {t('landing.banner.text2')}
              </span>
              <span className={cls(styles.text, styles[i18n.language])}>
                {t('landing.banner.text3')}
              </span>

            </div>
            <div className={styles.descBox}>{t('landing.banner.text4')}</div>
            {/** NOTE: 这个空 div 是因为里面的样式是 inline-flex ，外部需要这个空 div 换行 */}
            <div className={cls(styles.featureBox, styles.first, styles[i18n.language])}>
              <div className={styles.feature}>
                <img
                  className={styles.featureIcon}
                  src={commonUtils.getImagePath('homePage/camera-icon.png')}
                  alt=''
                />
                <span className={styles.featureText}>{t('landing.banner.feature1')}</span>
              </div>
              <div className={styles.feature}>
                <img
                  className={styles.featureIcon}
                  src={commonUtils.getImagePath('homePage/analysis-icon.png')}
                  alt=''
                />
                <span className={styles.featureText}>{t('landing.banner.feature2')}</span>
              </div>
            </div>
            {/** NOTE: 这个空 div 是因为里面的样式是 inline-flex ，外部需要这个空 div 换行 */}
            <div className={cls(styles.featureBox, styles[i18n.language])}>
              <div className={styles.feature}>
                <img
                  className={styles.featureIcon}
                  src={commonUtils.getImagePath('homePage/emotion-icon.png')}
                  alt=''
                />
                <span className={styles.featureText}>{t('landing.banner.feature3')}</span>
              </div>
              <div className={cls(styles.feature, styles.heat)}>
                <img
                  className={styles.featureIcon}
                  src={commonUtils.getImagePath('homePage/heat-icon.png')}
                  alt=''
                />
                <span className={styles.featureText}>{t('landing.banner.feature4')}</span>
              </div>
            </div>
            <div className={styles.btnBox}>
              {
                hasUserInfo
                  ? corpService.corpInfo?.freeTrial && !corpService.corpInfo.hasApply
                    ? <FreeTrialBtn />
                    : <ContactUsBtn />
                  : <StartBtn />
              }
            </div>
          </div>
        </div>
        <div className={styles.infoBox}>
          <div className={styles.infoContent}>
            <div className={styles.infoTitle}>{t('landing.info.title')}</div>
            <p className={styles.infoSubTitle}>{t('landing.info.subTitle')}</p>
            <img
              className={styles.infoBg}
              src={commonUtils.getImagePath('homePage/info-bg.png')}
              alt=''
            />
            <img
              className={styles.infoPic}
              src={commonUtils.getImagePath(
                i18n.language === 'zh' ? 'homePage/info-pic-zh.png' : 'homePage/info-pic-en.png'
              )}
              alt=''
            />
            <div className={styles.infoDetail}>
              <img
                className={cls(styles.colorfulBall)}
                src={commonUtils.getImagePath('homePageMobile/colorful-ball.png')}
                alt=''
              />
              <div className={styles.detailBox}>
                <div className={styles.detailTitle}>
                  <span className={styles.block}></span>
                  <span>{t('landing.info.detail1')}</span>
                </div>
                <div className={cls(styles.detailDescBox)}>
                  <span className={styles.detailDesc}>{t('landing.info.detail1Desc')}</span>
                </div>
                <img
                  className={styles.infoIntroPic}
                  src={commonUtils.getImagePath(
                    i18n.language === 'zh'
                      ? 'homePage/info-replace-pic-1-zh.png'
                      : 'homePage/info-replace-pic-1-en.png'
                  )}
                  alt=''
                />
                <div className={cls(styles.detailBtnBox)}>
                  {
                    hasUserInfo ? <ContactUsBtn /> : <StartBtn />
                  }
                </div>
              </div>
            </div>
            <div className={styles.infoDetail}>
              <img
                className={cls(styles.colorfulBall, styles.second)}
                src={commonUtils.getImagePath('homePageMobile/colorful-ball-1.png')}
                alt=''
              />
              <div className={cls(styles.detailBox)}>
                <div className={cls(styles.detailTitle)}>
                  <span className={cls(styles.block)}></span>
                  <span className={cls(styles.titleText)}>
                    {t('landing.info.detail2')}
                  </span>
                </div>
                <div className={cls(styles.detailDescBox)}>
                  <span className={cls(styles.detailDesc)}>
                    {t('landing.info.detail2Desc')}
                  </span>
                </div>
                <img
                  className={styles.infoIntroPic}
                  src={commonUtils.getImagePath(
                    i18n.language === 'zh'
                      ? 'homePage/info-replace-pic-2-zh.png'
                      : 'homePage/info-replace-pic-2-en.png'
                  )}
                  alt=''
                />
                <div className={cls(styles.detailBtnBox)}>
                  {
                    hasUserInfo ? <ContactUsBtn /> : <StartBtn />
                  }
                </div>
              </div>
            </div>
            <div className={styles.infoDetail}>
              <div className={styles.detailBox}>
                <div className={styles.detailTitle}>
                  <span className={styles.block}></span>
                  <span>{t('landing.info.detail3')}</span>
                </div>
                <div className={styles.detailDescBox}>
                  <span className={styles.detailDesc}>{t('landing.info.detail3Desc')}</span>
                </div>
                <img
                  className={styles.infoIntroPic}
                  src={commonUtils.getImagePath(
                    i18n.language === 'zh'
                      ? 'homePage/info-replace-pic-3-zh.png'
                      : 'homePage/info-replace-pic-3-en.png'
                  )}
                  alt=''
                />
                <div className={styles.detailBtnBox}>
                  {
                    hasUserInfo ? <ContactUsBtn /> : <StartBtn />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.advanceBox}>
          <p className={styles.advanceTitle}>{t('landing.advantages.title')}</p>
          <div className={styles.advanceBoxContent}>
            <div
              className={cls(styles.advanceItem, styles[i18n.language], styles.one)}
            >
              <div className={cls(styles.itemPicBox, styles.one)}></div>
              <p className={styles.itemTitle}>{t('landing.advantages.item1Title')}</p>
              <p className={styles.itemDesc}>
                <Trans
                  i18nKey='landing.advantages.item1Desc'
                  components={{ tmp: <span className={styles.descBold} /> }}
                />
              </p>
            </div>
            <div
              className={cls(styles.advanceItem, styles[i18n.language], styles.two)}
            >
              <div className={cls(styles.itemPicBox, styles.two)}></div>
              <p className={styles.itemTitle}>{t('landing.advantages.item2Title')}</p>
              <p className={styles.itemDesc}>
                <Trans
                  i18nKey='landing.advantages.item2Desc'
                  components={{ tmp: <span className={styles.descBold} /> }}
                />
              </p>
            </div>
            <div
              className={cls(styles.advanceItem, styles[i18n.language], styles.three)}
            >
              <div className={cls(styles.itemPicBox, styles.three)}></div>
              <p className={styles.itemTitle}>{t('landing.advantages.item3Title')}</p>
              <p className={styles.itemDesc}>
                <Trans
                  i18nKey='landing.advantages.item3Desc'
                  components={{ tmp: <span className={styles.descBold} /> }}
                />
              </p>
            </div>
            <div
              className={cls(styles.advanceItem, styles[i18n.language], styles.four)}
            >
              <div className={cls(styles.itemPicBox, styles.four)}></div>
              <p className={styles.itemTitle}>{t('landing.advantages.item4Title')}</p>
              <p className={styles.itemDesc}>
                <Trans
                  i18nKey='landing.advantages.item4Desc'
                  components={{ tmp: <span className={styles.descBold} /> }}
                />
              </p>
            </div>
            <div
              className={cls(styles.advanceItem, styles[i18n.language], styles.five)}
            >
              <div className={cls(styles.itemPicBox, styles.five)}></div>
              <p className={styles.itemTitle}>{t('landing.advantages.item5Title')}</p>
              <p className={styles.itemDesc}>
                <Trans
                  i18nKey='landing.advantages.item5Desc'
                  components={{ tmp: <span className={styles.descBold} /> }}
                />
              </p>
            </div>
          </div>
        </div>
        <div className={styles.serviceBox}>
          <p className={styles.serviceTitle}>{t('landing.service.title')}</p>
          <p className={styles.serviceDesc}>{t('landing.service.desc')}</p>
          <div className={styles.serviceBoxContent}>
            <div className={styles.top}>
              <div className={styles.topBox}>
                <div className={styles.topTitle}>
                  <img src={commonUtils.getImagePath('homePage/service-top-title.png')} alt='' />
                  <span>{t('landing.service.topTitle')}</span>
                </div>
                <div className={styles.topRow}>
                  <div className={styles.topRowCol}>
                    <img src={commonUtils.getImagePath('homePage/service-top-check.png')} alt='' />
                    <span>{t('landing.service.topRow1')}</span>
                  </div>
                  <div className={styles.topRowCol}>
                    <img src={commonUtils.getImagePath('homePage/service-top-check.png')} alt='' />
                    <span>{t('landing.service.topRow2')}</span>
                  </div>
                  <div className={styles.topRowCol}>
                    <img src={commonUtils.getImagePath('homePage/service-top-check.png')} alt='' />
                    <span>{t('landing.service.topRow3')}</span>
                  </div>
                  <div className={styles.topRowCol}>
                    <img src={commonUtils.getImagePath('homePage/service-top-check.png')} alt='' />
                    <span>{t('landing.service.topRow4')}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.bottom}>
              <div className={styles.bottomBox}>
                <div className={styles.bottomTitle}>
                  <img src={commonUtils.getImagePath('homePage/service-bottom-title.png')} alt='' />
                  <span>{t('landing.service.bottomTitle')}</span>
                </div>
                <div className={styles.bottomBlock}>
                  <div className={styles.blockRow}>
                    <div className={styles.blockRowCol}>
                      <img src={commonUtils.getImagePath('homePage/service-bottom-check.png')} alt='' />
                      <span>{t('landing.service.bottomRow1')}</span>
                    </div>
                    <div className={styles.blockRowCol}>
                      <img src={commonUtils.getImagePath('homePage/service-bottom-check.png')} alt='' />
                      <span>{t('landing.service.bottomRow2')}</span>
                    </div>
                    <div className={styles.blockRowCol}>
                      <img src={commonUtils.getImagePath('homePage/service-bottom-check.png')} alt='' />
                      <span>{t('landing.service.bottomRow3')}</span>
                    </div>
                    <div className={styles.blockRowCol}>
                      <img src={commonUtils.getImagePath('homePage/service-bottom-check.png')} alt='' />
                      <span>{t('landing.service.bottomRow4')}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer} >
          <div className={styles.footerBox}>
            <div className={styles.footerCover}></div>
            <div className={cls(styles.footerContent,
              browserType === 'firefox' && styles.firefox,
              platformType === 'ios' && styles.ios,
            )}>
              <img
                className={styles.footerContentBg}
                src={commonUtils.getImagePath('homePageMobile/footer-content-bg.png')}
                alt=''
              />
              <img
                className={styles.footerBrand}
                // src={commonUtils.getImagePath('homePage/footer-brand-mz.png')}
                src={commonUtils.getImagePath('homePage/minglue-adeff.png')}
                alt=''
              />
              <p className={styles.footerTitle}>{t('landing.footer.title')}</p>
              <p className={styles.belongDesc}>
                <a
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  target='_blank'
                  href={
                    i18n.language === 'zh'
                      ? 'https://www.mininglamp.com/'
                      : 'https://www.mininglamp.com/en/'
                  }
                >
                  <Trans
                    i18nKey='landing.footer.belongDesc'
                    components={{ tmp: <span className={styles.corp} /> }}
                  />
                </a>
              </p>
              <div className={styles.brandInfo}>
                <div className={styles.info}>
                  <img src={commonUtils.getImagePath('homePage/footer-email.png')} alt='' />
                  <span>{t('landing.footer.email')}: Adeff@mininglamp.com</span>
                </div>
              </div>
              {
                INTERNAL_HOST.includes(location.hostname) &&
                <p className={styles.ba}>京ICP备09014037号-53</p>
              }
            </div>
          </div>
        </div>
        {showCookieDrawer && <CookieAcceptNotification />}
        <AigcPromotionDrawer
          visible={showAigcPromotionDrawer}
          onClose={closeAigcPromotionDrawer}
          onRegister={handleAigcRegister}
        />
        {userInfo === null && showAigcEntry && <AigcPromoEntry mobile onClick={openAigcPromotionDrawer} />}
      </div>
    </>
  )
}

export default observer(HomePageMobile)
